(() => {
  const money = (cents, currency, locale) => {
    try { return new Intl.NumberFormat(locale || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(Number(cents || 0) / 100); }
    catch (_error) { return `£${(Number(cents || 0) / 100).toFixed(2)}`; }
  };
  const firstNumber = (value) => Number((String(value || '').match(/\d+/) || [0])[0]);
  const hasPots = (value) => /pot|lid/i.test(String(value || ''));
  const largeTinCount = (value) => {
    const title = String(value || '');
    const leading = title.match(/^\s*(\d+)\s*x\s*2[.,]5/i);
    const trailing = title.match(/2[.,]5\s*kg\s*x\s*(\d+)/i);
    return Number(leading?.[1] || trailing?.[1] || 1);
  };

  const initialise = (root = document) => {
    root.querySelectorAll('[data-minati-box-builder]:not([data-box-ready])').forEach((form) => {
      form.dataset.boxReady = 'true';
      const peopleInput = form.querySelector('[data-people]');
      const countElement = form.querySelector('[data-box-count]');
      const totalElement = form.querySelector('[data-box-total]');
      const messageElement = form.querySelector('[data-box-message]');
      const submitButton = form.querySelector('[data-box-submit]');
      const currency = form.dataset.currency || 'GBP';
      const locale = form.dataset.locale || 'en-GB';
      const people = () => Math.max(1, Math.min(48, Number(peopleInput.value) || 1));

      const syncVariant = (card, choose = false) => {
        const select = card.querySelector('[data-box-variant]');
        const input = card.querySelector('[data-box-selection]');
        if (!select || !input) return;
        const option = select.options[select.selectedIndex];
        input.value = option.value;
        input.dataset.price = option.dataset.price || '0';
        if (choose) input.checked = true;
        const price = card.querySelector('[data-box-price]');
        if (price) price.textContent = money(input.dataset.price, currency, locale);
        const image = card.querySelector('.minati-box__product-image img');
        const nextImage = option.dataset.image || card.dataset.defaultImage;
        if (image && nextImage) {
          image.src = nextImage;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          if (option.dataset.imageAlt) image.alt = option.dataset.imageAlt;
        }
      };

      const chooseVariantFor = (card, guests, servingsPerUnit, filter = () => true) => {
        const select = card.querySelector('[data-box-variant]');
        if (!select) return;
        const candidates = [...select.options].filter((option) => !option.disabled && filter(option)).map((option) => {
          const units = firstNumber(option.dataset.title || option.textContent);
          return { option, capacity: (units || 1) * servingsPerUnit };
        }).sort((a, b) => a.capacity - b.capacity);
        const match = candidates.find(({ capacity }) => capacity >= guests) || candidates[candidates.length - 1];
        if (match) select.value = match.option.value;
      };

      const selectedDoughCard = () => form.querySelector('[data-role="dough"] [data-box-selection]:checked')?.closest('[data-box-product]');
      const selectedTitle = (card) => {
        const select = card?.querySelector('[data-box-variant]');
        return select ? (select.options[select.selectedIndex]?.dataset.title || '') : '';
      };
      const switchSelectedDoughPots = (includePots) => {
        const card = selectedDoughCard();
        const select = card?.querySelector('[data-box-variant]');
        if (!select) return;
        const currentPack = firstNumber(selectedTitle(card));
        const matches = [...select.options].filter((option) => {
          const title = option.dataset.title || option.textContent;
          return !option.disabled && firstNumber(title) === currentPack && hasPots(title) === includePots;
        });
        const preferred = includePots ? matches[0] : (matches.find((option) => /semolina/i.test(option.dataset.title || option.textContent)) || matches[0]);
        if (preferred) { select.value = preferred.value; syncVariant(card); }
      };
      const chooseTomatoPack = (card, guests, pizzasPerTin, countTins) => {
        const select = card.querySelector('[data-box-variant]');
        if (!select) return;
        const candidates = [...select.options].filter((option) => !option.disabled).map((option) => {
          const tins = Math.max(1, countTins(option.dataset.title || option.textContent));
          const packs = Math.ceil(guests / (tins * pizzasPerTin));
          return { option, tins, packs, coverage: packs * tins * pizzasPerTin };
        }).sort((a, b) => a.coverage - b.coverage || a.packs - b.packs);
        const match = candidates[0];
        if (match) select.value = match.option.value;
      };

      const recommend = (card, quantity, copy) => {
        const input = card.querySelector('[data-box-selection]');
        const note = card.querySelector('[data-box-recommendation]');
        if (input) input.dataset.quantity = String(Math.max(1, quantity));
        const quantityInput = card.querySelector('[data-box-qty-input]');
        if (quantityInput) quantityInput.value = String(Math.max(1, quantity));
        if (note) { note.hidden = false; note.textContent = copy; }
      };
      const updateTomatoYield = (card, pizzasPerTin, countTins, tinDescription) => {
        const guests = people();
        const select = card.querySelector('[data-box-variant]');
        const tins = select ? Math.max(1, countTins(select.options[select.selectedIndex]?.dataset.title)) : 1;
        const packs = Math.ceil(guests / (tins * pizzasPerTin));
        const packCoverage = Math.round(tins * pizzasPerTin);
        const totalTins = packs * tins;
        const totalCoverage = Math.round(totalTins * pizzasPerTin);
        const packWord = packs === 1 ? 'pack' : 'packs';
        recommend(card, packs, `This selected pack has ${tins} ${tinDescription}${tins === 1 ? '' : 's'} and can top roughly ${packCoverage} pizzas. For ${guests} people: ${packs} ${packWord} (${totalTins} tins), covering about ${totalCoverage} pizzas.`);
      };

      const updateRecommendations = () => {
        const guests = people();
        peopleInput.value = String(guests);
        form.querySelector('[data-plan-dough]').textContent = `${guests} dough ball${guests === 1 ? '' : 's'}`;
        form.querySelector('[data-plan-copy]').textContent = `${guests} generous pizza${guests === 1 ? '' : 's'} · one each`;
        form.querySelector('[data-box-summary-note]').textContent = `Built for ${guests} ${guests === 1 ? 'person' : 'people'}`;

        form.querySelectorAll('[data-role="dough"]').forEach((card) => {
          const keepPots = hasPots(selectedTitle(card));
          chooseVariantFor(card, guests, 1, (option) => hasPots(option.dataset.title || option.textContent) === keepPots); syncVariant(card);
          const select = card.querySelector('[data-box-variant]');
          const pack = select ? firstNumber(select.options[select.selectedIndex]?.dataset.title) : 0;
          const quantity = pack ? Math.ceil(guests / pack) : 1;
          recommend(card, quantity, pack ? `Recommended: ${quantity} × ${pack}-ball pack` : `Choose a pack covering ${guests}`);
        });
        form.querySelectorAll('[data-role="proving"]').forEach((card) => {
          const trays = Math.ceil(guests / 6);
          const select = card.querySelector('[data-box-variant]');
          let bundleQuantity = 1;
          if (select) {
            const exact = [...select.options].find((option) => {
              const title = option.dataset.title || option.textContent;
              const trayMatch = title.match(/(\d+)\s*trays?/i);
              const lidMatch = title.match(/(\d+)\s*lids?/i);
              return !option.disabled && Number(trayMatch?.[1]) === trays && Number(lidMatch?.[1]) === trays;
            });
            if (exact) select.value = exact.value;
            else {
              const single = [...select.options].find((option) => !option.disabled && /1\s*tray\s*and\s*1\s*lid/i.test(option.dataset.title || option.textContent));
              if (single) { select.value = single.value; bundleQuantity = trays; }
            }
            syncVariant(card);
          }
          recommend(card, bundleQuantity, `Recommended: ${trays} tray${trays === 1 ? '' : 's'} + ${trays} lid${trays === 1 ? '' : 's'} for ${guests} dough balls`);
        });
        form.querySelectorAll('[data-role="sauce-ready"]').forEach((card) => {
          chooseVariantFor(card, guests, 8); syncVariant(card);
          const select = card.querySelector('[data-box-variant]');
          const tins = select ? Math.max(1, firstNumber(select.options[select.selectedIndex]?.dataset.title)) : 1;
          const packs = Math.ceil(guests / (tins * 8));
          const totalTins = packs * tins;
          recommend(card, packs, `Recommended: ${packs} × ${tins}-tin pack (${totalTins} tin${totalTins === 1 ? '' : 's'} total). Each 800g tin covers about 8 pizzas.`);
        });
        form.querySelectorAll('[data-role="sauce-400"]').forEach((card) => {
          chooseTomatoPack(card, guests, 6, firstNumber); syncVariant(card);
          updateTomatoYield(card, 6, firstNumber, '× 400g tin');
        });
        form.querySelectorAll('[data-role="sauce-gold"]').forEach((card) => {
          chooseTomatoPack(card, guests, 37.5, largeTinCount); syncVariant(card);
          updateTomatoYield(card, 37.5, largeTinCount, '× 2.5kg Rega Gold tin');
        });
        form.querySelectorAll('[data-role="sauce-solania"]').forEach((card) => {
          chooseTomatoPack(card, guests, 37.5, largeTinCount); syncVariant(card);
          updateTomatoYield(card, 37.5, largeTinCount, '× 2.5kg Solania tin');
        });
        form.querySelectorAll('[data-role="cheese"]').forEach((card) => {
          const quantity = Math.ceil(guests / (Number(card.dataset.servings) || 20));
          recommend(card, quantity, `Recommended: ${quantity} pack${quantity === 1 ? '' : 's'} for ${guests}`);
        });
      };

      const activeSelections = () => [...form.querySelectorAll('[data-box-selection]:checked')].filter((input) => {
        const panel = input.closest('[data-sauce-panel]');
        return input.value && (!panel || !panel.hidden);
      });

      const updateProving = (answerChanged = false) => {
        const proving = form.querySelector('[data-proof-products]');
        const proofChoice = form.querySelector('[data-proof-choice]');
        const doughChoice = form.querySelector('input[name="box-dough"]:checked');
        const doughSkipped = Boolean(doughChoice && !doughChoice.value);
        const trayAnswer = form.querySelector('[name="proof-answer"]:checked')?.value === 'add-tray';
        const doughCard = selectedDoughCard();
        const doughHasPots = hasPots(selectedTitle(doughCard));
        const priorOrigin = form.dataset.proofOrigin;
        const title = form.querySelector('[data-proof-title]');
        const intro = form.querySelector('[data-proof-intro]');
        const noLabel = form.querySelector('[data-proof-no]');
        const yesLabel = form.querySelector('[data-proof-yes]');

        if (doughSkipped) {
          title.textContent = 'No proving equipment needed.';
          intro.textContent = 'You’ve chosen to skip dough, so we’ve skipped the proving step too.';
          proofChoice.hidden = true;
          proving.hidden = true;
          form.querySelector('[name="proof-answer"][value="skip-tray"]').checked = true;
          proving.querySelectorAll('[data-box-selection]').forEach((input) => { input.checked = false; });
          delete form.dataset.proofOrigin;
          return;
        }
        proofChoice.hidden = false;

        if (answerChanged) {
          if (trayAnswer && doughHasPots) {
            form.dataset.proofOrigin = 'pots';
            switchSelectedDoughPots(false);
          } else if (!trayAnswer && priorOrigin === 'pots') {
            switchSelectedDoughPots(true);
          }
        }
        const selectedNowHasPots = hasPots(selectedTitle(selectedDoughCard()));

        if (!doughCard) {
          title.textContent = 'Do you have something to prove the dough in?';
          intro.textContent = 'Select your dough above and we’ll make sure you have the right proving setup.';
          noLabel.textContent = 'Yes, I’m sorted'; yesLabel.textContent = 'No, show me what I need';
        } else if (selectedNowHasPots && !trayAnswer) {
          form.dataset.proofOrigin = 'pots';
          title.textContent = 'You have proving pots and lids included with your dough.';
          intro.textContent = 'Would you like to upgrade to reusable plastic trays and lids? They last longer, stack neatly and fit easily in the fridge.';
          noLabel.textContent = 'No, keep my pots & lids'; yesLabel.textContent = 'Yes, upgrade to trays';
        } else if (trayAnswer && form.dataset.proofOrigin === 'pots') {
          title.textContent = 'Upgrade to reusable proving trays and lids?';
          intro.textContent = 'We’ll remove the pots-and-lids dough variant and match the correct reusable trays to your headcount.';
          noLabel.textContent = 'No, use the included pots'; yesLabel.textContent = 'Yes, keep my tray upgrade';
        } else {
          form.dataset.proofOrigin = 'standard';
          title.textContent = 'Do you have something to prove the dough in?';
          intro.textContent = 'Your selected dough does not include proving pots. A reusable tray and lid keeps the dough protected while it rises.';
          noLabel.textContent = 'Yes, I already have something'; yesLabel.textContent = 'No, add trays & lids';
        }

        proving.hidden = !trayAnswer;
        const provingInput = proving.querySelector('[data-box-selection]');
        if (provingInput) provingInput.checked = trayAnswer;
      };

      const updateConditionals = (event) => {
        updateProving(event?.target?.name === 'proof-answer');
        const sauceStyle = form.querySelector('[name="sauce-style"]:checked')?.value || 'ready';
        form.querySelectorAll('[data-sauce-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.saucePanel !== sauceStyle;
          if (panel.hidden) panel.querySelectorAll('[data-box-selection]').forEach((input) => { input.checked = false; });
        });
      };

      const updateSummary = () => {
        const selected = activeSelections();
        countElement.textContent = String(selected.reduce((sum, input) => sum + Number(input.dataset.quantity || 1), 0));
        totalElement.textContent = money(selected.reduce((sum, input) => sum + Number(input.dataset.price || 0) * Number(input.dataset.quantity || 1), 0), currency, locale);
        form.querySelectorAll('[data-box-product]').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('[data-box-selection]')?.checked)));
        form.querySelectorAll('[data-box-step]').forEach((step) => {
          const error = step.querySelector('[data-step-error]');
          if (error && selected.some((input) => step.contains(input))) error.hidden = true;
        });
      };

      form.addEventListener('click', (event) => {
        const clearExtras = event.target.closest('[data-clear-extras]');
        if (clearExtras) {
          form.querySelectorAll('[data-step-role="extras"] [data-box-selection]').forEach((input) => { input.checked = false; });
          messageElement.textContent = '';
          updateSummary();
          return;
        }
        const quantityButton = event.target.closest('[data-box-qty-minus], [data-box-qty-plus]');
        if (quantityButton) {
          const card = quantityButton.closest('[data-box-product]');
          const quantityInput = card.querySelector('[data-box-qty-input]');
          const selection = card.querySelector('[data-box-selection]');
          const adjustment = quantityButton.hasAttribute('data-box-qty-plus') ? 1 : -1;
          const quantity = Math.max(1, Math.min(99, (Number(quantityInput.value) || 1) + adjustment));
          quantityInput.value = String(quantity);
          selection.dataset.quantity = String(quantity);
          selection.checked = true;
          messageElement.textContent = '';
          updateSummary();
          return;
        }
        if (event.target.closest('[data-people-minus]')) peopleInput.value = String(people() - 1);
        else if (event.target.closest('[data-people-plus]')) peopleInput.value = String(people() + 1);
        else return;
        updateRecommendations(); updateSummary();
      });
      form.addEventListener('change', (event) => {
        const select = event.target.closest('[data-box-variant]');
        if (select) {
          const card = select.closest('[data-box-product]');
          syncVariant(card, true);
          if (card.dataset.role === 'sauce-400') updateTomatoYield(card, 6, firstNumber, '× 400g tin');
          if (card.dataset.role === 'sauce-gold') updateTomatoYield(card, 37.5, largeTinCount, '× 2.5kg Rega Gold tin');
          if (card.dataset.role === 'sauce-solania') updateTomatoYield(card, 37.5, largeTinCount, '× 2.5kg Solania tin');
        }
        const quantityInput = event.target.closest('[data-box-qty-input]');
        if (quantityInput) {
          const card = quantityInput.closest('[data-box-product]');
          const selection = card.querySelector('[data-box-selection]');
          const quantity = Math.max(1, Math.min(99, Number(quantityInput.value) || 1));
          quantityInput.value = String(quantity);
          selection.dataset.quantity = String(quantity);
          selection.checked = true;
        }
        const changedDoughCard = event.target.closest('[data-role="dough"]');
        if (changedDoughCard && form.querySelector('[name="proof-answer"]:checked')?.value === 'add-tray' && hasPots(selectedTitle(changedDoughCard))) {
          form.dataset.proofOrigin = 'pots';
          switchSelectedDoughPots(false);
        }
        if (event.target === peopleInput) updateRecommendations();
        updateConditionals(event); messageElement.textContent = ''; updateSummary();
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault(); messageElement.textContent = '';
        let valid = true;
        form.querySelectorAll('[data-box-step][data-required="true"]').forEach((step) => {
          const error = step.querySelector('[data-step-error]');
          if (!activeSelections().some((input) => step.contains(input))) { valid = false; if (error) error.hidden = false; }
          else if (error) error.hidden = true;
        });
        if (!valid) {
          messageElement.textContent = 'Please complete the dough, sauce and cheese steps.';
          form.querySelector('[data-step-error]:not([hidden])')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
        }
        const quantities = new Map();
        activeSelections().forEach((input) => quantities.set(input.value, (quantities.get(input.value) || 0) + Number(input.dataset.quantity || 1)));
        const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
        if (!items.length) {
          messageElement.textContent = 'Your box is empty. Choose at least one item before adding it to your basket.';
          return;
        }
        submitButton.disabled = true; submitButton.setAttribute('aria-busy', 'true'); submitButton.textContent = 'Adding your box…';
        try {
          const response = await fetch(form.dataset.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.description || result.message || 'We could not add that selection.');
          window.location.assign(form.dataset.cartUrl);
        } catch (error) {
          messageElement.textContent = error.message || 'Something went wrong. Please try again.';
          submitButton.disabled = false; submitButton.removeAttribute('aria-busy'); submitButton.textContent = 'Add box to basket';
        }
      });
      updateRecommendations(); updateConditionals(); updateSummary();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
